import '../../sass/Testimonials.scss'
import EmblaCarousel from 'embla-carousel'

export function estimateReadingTimeInMS(text, wps = 3) {
    const words = text.trim().split(/\s+/).length

    return Math.ceil(words / wps) * 1000
}

const timeouts = new Map()
function stopEmblaAutoplay(index) {
    const timeout = timeouts.get(index)
    if (timeout) {
        clearTimeout(timeout)
        timeouts.set(index, undefined)
    }
}

function resetEmblaAutoplay(index, emblaApi) {
    stopEmblaAutoplay(index)

    const duration = Math.max(4000, estimateReadingTimeInMS(emblaApi.slideNodes()[emblaApi.selectedScrollSnap()].innerText))
    const timeout = setTimeout(() => {
        emblaApi.scrollNext()
    }, duration)
    timeouts.set(index, timeout)
}

let observer = undefined
const emblaApiMap = new Map()

const InViewportCallback = entries => {
    for (let entry of entries) {
        const el = entry.target
        const index = el.dataset?.index
        const loaded = el.dataset?.loaded === 'true'
        if (entry.isIntersecting) {
            if (!loaded) {
                let emblaApi = emblaApiMap.get(index)
                resetEmblaAutoplay(index, emblaApi)

                emblaApi.on('init', () => {
                    resetEmblaAutoplay(index, emblaApi)
                })

                emblaApi.on('select', () => {
                    stopEmblaAutoplay(index, emblaApi)
                })

                emblaApi.on('settle', () => {
                    resetEmblaAutoplay(index, emblaApi)
                })

                el.dataset.loaded = 'true'
            }
        } else {
            if (index && loaded) {
                stopEmblaAutoplay(index)
                const emblaApi = emblaApiMap.get(index)

                emblaApi.off('init', () => {
                    resetEmblaAutoplay(index, emblaApi)
                })

                emblaApi.off('select', () => {
                    stopEmblaAutoplay(index, emblaApi)
                })

                emblaApi.off('settle', () => {
                    resetEmblaAutoplay(index, emblaApi)
                })

                el.dataset.loaded = 'false'
            }
        }
    }
}

const emblaOptions = {
    loop: true,
}

const buttonCallback = (button, emblaApi) => (() => {
    if (button.classList.contains('Next')) {
        emblaApi.scrollNext()
    } else {
        emblaApi.scrollPrev()
    }
})

export function createObserver(headerHeight) {
    if (observer)
        observer.disconnect()

    observer = new IntersectionObserver(InViewportCallback, {
        root: null,
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
        threshold: 0.95,
    })

    const emblaNodes = document.getElementsByClassName('Testimonial--Items')
    let i = 0
    for (let emblaNode of emblaNodes) {
        const index = String(i)
        if (emblaNode.dataset.index !== index) {
            emblaNode.dataset.index = index
        }

        let emblaApi = emblaApiMap.get(index)
        if (!emblaApi) {
            emblaApi = EmblaCarousel(emblaNode, emblaOptions)
            emblaApiMap.set(index, emblaApi)

            const emblaParent = emblaNode.parentElement
            const buttons = emblaParent.getElementsByClassName('PrevNext')

            for (let button of buttons) {
                button.addEventListener('click', buttonCallback(button, emblaApi), {passive: true})
            }
        }

        observer.observe(emblaNode)
        ++i
    }
}
